export var RowEventType;
(function (RowEventType) {
    RowEventType[RowEventType["NOOP"] = 0] = "NOOP";
    RowEventType[RowEventType["ADD"] = 1] = "ADD";
    RowEventType[RowEventType["DELETE"] = 2] = "DELETE";
    RowEventType[RowEventType["MODIFY"] = 3] = "MODIFY";
    RowEventType[RowEventType["MODIFY_ADD"] = 4] = "MODIFY_ADD";
})(RowEventType || (RowEventType = {}));
